import cx from 'classnames';
import styles from './CartLink.module.scss';

import React, { createRef } from 'react';
import { useTranslation } from 'react-i18next';

import { LocaleLink } from 'components/ContentLink/LocaleLink';
import { useNavBarContext } from 'components/NavBarContext/NavBarContext';
import { redesignV2RoutePath } from 'constants/redesignV2';
import { Environment } from 'utils/Environment';
import { stringFormatForTestAttr } from 'utils/StringFormatForTest';
import { CartIcon } from './CartIcon';
import { useCartContext } from 'components/Cart/hooks/useCartContext';

type CartLinkProps = { isTransparent?: boolean };

export const CartLink: React.FC<CartLinkProps> = ({ isTransparent }) => {
  const ref = createRef<HTMLAnchorElement>();
  const { t, i18n } = useTranslation();
  const { hideCartIcon } = useNavBarContext();
  const { checkout } = useCartContext();
  const itemsInCart = checkout.count;
  const isCloverMerchant = Environment.current.isExistingMerchant;

  if (isCloverMerchant || hideCartIcon || i18n.language !== 'en-US') return null;

  const props = {
    className: cx(styles.cartLink, isTransparent && styles.isTransparent),
    title: t('your-cart'),
    'aria-label': t('navigation-header.cart'),
    'data-testid': `${stringFormatForTestAttr(t('navigation-header.cart'))}`,
  };

  const icon = (
    <>
      <CartIcon />
      {itemsInCart > 0 && (
        <span className={cx(styles.cartLinkBubble, { [styles.cartLinkBubbleDouble]: itemsInCart > 9 })}>
          {itemsInCart}
        </span>
      )}
    </>
  );

  return (
    <LocaleLink innerRef={ref} to={redesignV2RoutePath.CART} {...props}>
      {icon}
    </LocaleLink>
  );
};
